import React from 'react';
import {Link} from 'react-router-dom';
import { inject, observer } from "mobx-react";

const FaqTextBulgarian = ({ feathersStore })=> {
  return(
    <div className="terms-text">
      <h2>Какви методи на плащане приемате?</h2>
      <p>
        Можете да видите методите за плащане <Link className="privacy-text" to="/paymentoptions">тук</Link>.
      </p>    
      <h2>
        По какви начини ще бъде доставена моята поръчка?
      </h2>
      <p>
        Можете да видите методите за доставка <Link className="privacy-text" to="/deliveryoptions">тук</Link>.
      </p>
      <h2>
        Мога ли да направя промени по поръчката си?
      </h2>
      <p>
      Можете да направите промени до момента на изпращане на поръчката. Моля, обадете се на {feathersStore.settings?.phoneNumbers?.find(p => p.numberEnabled)?.phoneNumber} или ни пишете през формата на сайта <Link className="privacy-text" to="/contact">тук</Link> или на имейл {feathersStore.settings?.email}, като посочите вашите данни и желаните промени.
      </p>
      <h2>
        Има ли физически магазин, който мога да посетя?
      </h2>
      <p>
      Можете да ни посетите на адрес {feathersStore.settings?.address}.
      </p>
    </div>
  )
}
    
export default inject('feathersStore')(observer(FaqTextBulgarian));